import React, { useEffect, useState, useRef } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const purchases = [['Jessica M.', 'Austin, TX, USA'], ['Ashley R.', 'Denver, CO, USA'], ['Michael T.', 'Nashville, TN, USA'], ['Danielle F.', 'Portland, OR, USA'], ['Ryan C.', 'Scottsdale, AZ, USA'], ['Samantha L.', 'San Diego, CA, USA']];
export function PurchaseToast() {
  const [visible, setVisible] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  const dismissTimer = useRef<number | undefined>();
  useEffect(() => {
    const show = () => {
      setPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      if (dismissTimer.current) window.clearTimeout(dismissTimer.current);
      dismissTimer.current = window.setTimeout(() => setVisible(false), 5000);
    };
    const first = window.setTimeout(show, 3500);
    const interval = window.setInterval(show, 18000);
    return () => {
      window.clearTimeout(first);
      window.clearInterval(interval);
      if (dismissTimer.current) window.clearTimeout(dismissTimer.current);
    };
  }, []);
  if (!visible) return null;
  return <aside aria-live="polite" className="fixed bottom-3 left-3 z-50 animate-toast-in sm:bottom-4 sm:left-4" data-id="element-175" data-mp="1z7oyov3ccbas">
      <div className="relative flex max-w-[274px] items-center gap-2.5 rounded-lg border-2 border-sport bg-white p-2.5 pr-8 shadow-2xl ring-2 ring-sport/20" data-id="element-176" data-mp="286aggo0znmai">
        <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-sport text-white" data-id="element-177" data-mp="1bhkt4i6le1h5">
          <ShoppingBagIcon className="h-4 w-4" aria-hidden="true" data-id="element-178" data-mp="1ffilftvnt3or" />
        </div>
        <div className="leading-tight" data-id="element-179" data-mp="1kf4zg5jbanym">
          <p className="text-xs font-display font-bold text-navy" data-id="element-180" data-mp="1p7elvbl7x5w5">
            {purchase[0]}{' '}
            <span className="font-sans font-medium text-muted" data-id="element-181" data-mp="rs0nfglsx9dc">
              · {purchase[1]}
            </span>
          </p>
          <p className="mt-0.5 text-xs font-bold text-electric" data-id="element-182" data-mp="wqbz7wvnpty7">
            just purchased STRENGTH READY™
          </p>
        </div>
        <button onClick={() => setVisible(false)} aria-label="Dismiss purchase notification" className="absolute right-1.5 top-1.5 rounded p-1 text-muted hover:text-navy focus:outline-none focus:ring-2 focus:ring-electric" data-id="element-183" data-mp="200gdhmsbckp0">
          <XIcon className="h-3.5 w-3.5" data-id="element-184" data-mp="24shkat6ppj7n" />
        </button>
      </div>
    </aside>;
}